import apiClient from "QueryClient/axiosClient";

export const publishSlot = (data) => {
  return apiClient.post("/oneGradSlot/addSlot", data);
};

export const editSlot = (data) => {
  return apiClient.put("/oneGradSlot/editSlot", data);
};
